import { ClipboardData, BlockElement } from 'roosterjs-editor-types';
import { NodeBlockElement, VTable } from 'roosterjs-editor-dom';
import {
    EditorPlugin,
    cacheGetContentSearcher,
    clearContentSearcherCache,
} from 'roosterjs-editor-core';
import { editTable, formatTable, replaceWithNode } from 'roosterjs-editor-api';
import { Paste } from 'roosterjs-editor-plugins';

// White space matching regex. It matches following chars:
// \s: white space
// \u00A0: no-breaking white space
// \u200B: zero width space
// \u3000: full width space (which can come from JPN IME)
const WHITESPACE_REGEX = /[\s\u00A0\u200B\u3000]+([^\s\u00A0\u200B\u3000]*)$/i;

function matchWhiteSpaces(source: string): string[] {
    return WHITESPACE_REGEX.exec(source);
}

// List all the roosterjs APIs used in plugins, and pass references for these APIs to plugins
// So that plugin code doesn't need to have roosterjs compiled into there .js file
export interface PluginUtils {
    cacheGetContentSearcher: typeof cacheGetContentSearcher;
    clearContentSearcherCache: typeof clearContentSearcherCache;
    replaceWithNode: typeof replaceWithNode;
    matchWhiteSpaces: typeof matchWhiteSpaces;
    editTable: typeof editTable;
    formatTable: typeof formatTable;
    pasteOriginal: (clipboardData: ClipboardData) => void;
    pasteText: (clipboardData: ClipboardData) => void;
    pasteAndMergeFormat: (clipboardData: ClipboardData) => void;
    isNodeBlockElement: (blockElement: BlockElement) => boolean;
    createVTable: (td: HTMLTableCellElement) => VTable;
}

export interface EditorPluginEx extends EditorPlugin {
    setPluginUtils: (utils: PluginUtils) => void;
}

export function createPluginUtils(pastePlugin: Paste): PluginUtils {
    return {
        cacheGetContentSearcher,
        clearContentSearcherCache,
        replaceWithNode,
        matchWhiteSpaces,
        editTable,
        formatTable,
        pasteOriginal: clipboardData => pastePlugin.pasteOriginal(clipboardData),
        pasteText: clipboardData => pastePlugin.pasteText(clipboardData),
        pasteAndMergeFormat: clipboardData => pastePlugin.pasteAndMergeFormat(clipboardData),
        isNodeBlockElement: (blockElement: BlockElement) => {
            return blockElement instanceof NodeBlockElement;
        },
        createVTable: (td: HTMLTableCellElement) => new VTable(td),
    };
}
